export const selectedReceipt = (state) => (state.selectedReceipt);
export const pagination = (state) => (state.pagination);
export const loading = (state) => state.loading;
export const receipts = (state) => Object.values(state.list || {});
export const detailsReceipt = (state) => (state.detailsReceipt);
export const detailsSelectedReceipts = (state) => (state.detailsSelectedReceipts);
